import { gql } from '@apollo/client';
import { createApolloQueriesString } from '../../helpers/apolloHelpers';
import { defaultResponse } from './defaultResponse';

const [
  parametersTypeString,
  parametersAssignString,
] = createApolloQueriesString([
  ['scrap_id', 'Int'],
  ['collections', '[InputCollectionId]'],
]);
export default function REMOVE_SCRAP_COLLECTIONS(responseString = '') {
  return gql`
    mutation RemoveScrapCollections(${parametersTypeString}) {
      removeScrapCollections(${parametersAssignString}) {
        ${defaultResponse}
      }
    }
  `;
}
